'use strict';

import {Point2D} from '../util/Geometry.js';
import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {Bounds} from '../content/BoxContent.js'

const privateMap = util.createPrivateMapper();

export class ImageRenderer {
  constructor(){
  }
  render(view, resource, control, session){
    // const resource = pv.resource;
    if (!view || !resource || !control) {
      return;
    }
    const disposition = control.box.disposition;
    const bounds = resource.bounds;
    const ctx = view.context2d;
    const vc = view.center;
    // const region = resource.getRegion();
    const z = disposition.zoom;
    const ofs = disposition.offset;

    const zsz = bounds.size.mul(z);

    const lt = bounds.position.mul(z).sub(zsz.div(2)).add(vc.add(ofs));
    // const rw = Math.min(region.position.x + region.size.x, resource.image.width) - region.position.x;
    // const rh = Math.min(region.position.y + region.size.y, resource.image.height) - region.position.y;
    ctx.save();

    const rotateCenter = vc;
    ctx.translate(rotateCenter.x, rotateCenter.y);
    ctx.rotate(disposition.angle);
    ctx.translate(-rotateCenter.x, -rotateCenter.y);

    ctx.drawImage(resource.image, lt.x, lt.y, zsz.x, zsz.y);
    ctx.restore();
    return true;
  };
};

export class ImageResource {
  constructor(image){
    const pv = privateMap(this);
    pv.image = image;
    pv.size = new Point2D(pv.image.width, pv.image.height);
    pv.bounds = new Bounds();
    pv.bounds.position.set(0, 0);
    pv.bounds.size.copy(pv.size);
  }
  get bounds(){
    return privateMap(this).bounds;
  }

  get type(){
    return 'image';
  }

  get size(){
    return privateMap(this).size.clone();
  }
  get image(){
    return privateMap(this).image;
  }

}

export class ImageResourceLoader {
  constructor(){
  }

  load(source, successCallback, params){
    const p = Object.assign({
      url: source.id,
      success: function(img) {
        successCallback(new ImageResource(img));
      }
    }, params);
    return util.loadImage(p);
    // const image = document.createElement('img');
    // return new Promise((resolve, reject) => {
    //   domUtil.addEventListener(image, 'load', function(ev){
    //     const resource = new ImageResource(image);
    //     resolve(resource);
    //   });
    //   domUtil.addEventListener(image, 'error', function(ev){
    //     reject(ev);
    //   });
    //   image.src = src;
    // });
  }
}
